import React from 'react';

const Privacy = () => {
  return (
    <div className="fade-in" style={{ maxWidth: '900px', margin: '0 auto' }}>
      <h1 style={{ fontSize: '32px', fontWeight: '800', marginBottom: '24px' }}>
        Privacy Policy
      </h1>
      <p style={{ color: 'var(--text-muted)', marginBottom: '30px' }}>
        Last updated: February 12, 2026
      </p>

      <div className="card" style={{ padding: '40px' }}>
        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '20px', fontWeight: '700', marginBottom: '16px' }}>
            1. Introduction
          </h2>
          <p style={{ color: 'var(--text-muted)', lineHeight: '1.8' }}>
            At Addison Mail, privacy isn't an afterthought—it's our foundation. This Privacy Policy 
            explains how we collect, use, store, and protect your information when you use our 
            secure email service.
          </p>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '20px', fontWeight: '700', marginBottom: '16px' }}>
            2. Information We Collect
          </h2>
          <h3 style={{ fontSize: '16px', fontWeight: '600', marginBottom: '12px' }}>Account Information</h3>
          <ul style={{ color: 'var(--text-muted)', lineHeight: '1.8', marginLeft: '20px', marginBottom: '16px' }}>
            <li>Username and password (encrypted)</li>
            <li>Email addresses (your aliases and accounts)</li>
            <li>Subscription tier and payment information</li>
          </ul>

          <h3 style={{ fontSize: '16px', fontWeight: '600', marginBottom: '12px' }}>Email Content</h3>
          <ul style={{ color: 'var(--text-muted)', lineHeight: '1.8', marginLeft: '20px', marginBottom: '16px' }}>
            <li><strong>Encrypted emails:</strong> We cannot read the content of PGP-encrypted emails</li>
            <li><strong>Unencrypted emails:</strong> Stored temporarily for delivery, then deleted from our servers</li>
            <li><strong>Metadata:</strong> Sender, recipient, subject, and timestamps (required for routing)</li>
          </ul>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '20px', fontWeight: '700', marginBottom: '16px' }}>
            3. How We Use Your Information
          </h2>
          <ul style={{ color: 'var(--text-muted)', lineHeight: '1.8', marginLeft: '20px' }}>
            <li>To provide and maintain our email service</li>
            <li>To process payments and manage your subscription</li>
            <li>To send service notifications (not marketing emails)</li>
            <li>To detect and prevent abuse or spam</li>
            <li>To improve our service based on usage patterns</li>
          </ul>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '20px', fontWeight: '700', marginBottom: '16px' }}>
            4. Data Storage & Security
          </h2>
          <p style={{ color: 'var(--text-muted)', lineHeight: '1.8', marginBottom: '16px' }}>
            <strong>Encryption at Rest:</strong> All data is encrypted using AES-256 when stored.
          </p>
          <p style={{ color: 'var(--text-muted)', lineHeight: '1.8', marginBottom: '16px' }}>
            <strong>Encryption in Transit:</strong> All connections use TLS 1.3.
          </p>
          <p style={{ color: 'var(--text-muted)', lineHeight: '1.8', marginBottom: '16px' }}>
            <strong>Zero-Knowledge:</strong> For PGP-encrypted emails, only you hold the keys. 
            We cannot decrypt your messages even if compelled.
          </p>
          <p style={{ color: 'var(--text-muted)', lineHeight: '1.8' }}>
            <strong>Data Location:</strong> Stored in Cloudflare's global infrastructure, 
            with primary servers in the EU for GDPR compliance.
          </p>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '20px', fontWeight: '700', marginBottom: '16px' }}>
            5. Your Rights (GDPR & CCPA)
          </h2>
          <ul style={{ color: 'var(--text-muted)', lineHeight: '1.8', marginLeft: '20px' }}>
            <li><strong>Right to Access:</strong> Request a copy of your data</li>
            <li><strong>Right to Deletion:</strong> Delete your account and all associated data</li>
            <li><strong>Right to Portability:</strong> Export your emails in standard formats</li>
            <li><strong>Right to Object:</strong> Opt out of any non-essential data processing</li>
          </ul>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '20px', fontWeight: '700', marginBottom: '16px' }}>
            6. What We DON'T Do
          </h2>
          <ul style={{ color: 'var(--text-muted)', lineHeight: '1.8', marginLeft: '20px' }}>
            <li>✗ We don't read your emails (encrypted or not)</li>
            <li>✗ We don't sell your data to third parties</li>
            <li>✗ We don't show you ads based on email content</li>
            <li>✗ We don't track you across the web</li>
            <li>✗ We don't share data with governments unless legally required</li>
          </ul>
        </section>

        <section>
          <h2 style={{ fontSize: '20px', fontWeight: '700', marginBottom: '16px' }}>
            7. Contact Us
          </h2>
          <p style={{ color: 'var(--text-muted)', lineHeight: '1.8' }}>
            Questions about privacy? Contact our Data Protection Officer at{' '}
            <a href="mailto:privacy@addisonelectronique.com" style={{ color: '#DC2626' }}>
              privacy@addisonelectronique.com
            </a>
          </p>
        </section>
      </div>
    </div>
  );
};

export default Privacy;

